export default __webpack_public_path__ + "brandLogo.6ead4d65.gif";